package com.eladfinish.bible.contest.screens.names.data

import com.eladfinish.bible.contest.network.spreadsheet.GoogleSheetContent
import com.eladfinish.bible.contest.network.spreadsheet.GoogleSheetItem

/** elfifo4/names-in-bible — the database of the Bible's names, shown in the app's Names screen. */
object NamesDatabase {
    const val MEN_DIRECTORY = "men"
    const val WOMEN_DIRECTORY = "women"

    /** The database is based on this author's work, credited (with a link) wherever it's shown. */
    const val CREDIT_NAME = "ירעם נתניהו"
    const val CREDIT_URL =
        "https://leshoniada.co.il/2023/05/10/%d7%9e%d7%90%d7%92%d7%a8-%d7%a9%d7%9e%d7%95%d7%aa-%d7%a9%d7%9c-%d7%91%d7%a0%d7%99%d7%9d-%d7%95%d7%91%d7%a0%d7%95%d7%aa-%d7%a9%d7%9e%d7%95%d7%aa-%d7%9e%d7%94%d7%aa%d7%a0%d7%9a/"

    const val NOTES_HEADER = "הערות / משמעות השם"
}

/**
 * One name: who bore it — [bearers], each a (description, source) pair, numbered when there are
 * several — and the [notes] on it (remarks, the name's meaning).
 */
data class BibleName(
    val name: String,
    val bearers: List<Pair<String, String>>,
    val notes: String,
) {
    /** The text the app's Names screen shows for this name (and finds verse references in). */
    val description: String
        get() = bearers.withIndex().joinToString(separator = "\n") {
            "${it.index.plus(1)}. ".takeIf { bearers.size > 1 }.orEmpty() +
                "${it.value.first} (${it.value.second})"
        } + "\n" + NamesDatabase.NOTES_HEADER + ":" + "\n" + notes
}

/**
 * A row of a names-in-bible all.json: name, bearers' descriptions, their sources, then notes.
 * Null for names marked with a trailing "*", which aren't shown.
 */
fun GoogleSheetContent.toBibleName(): BibleName? {
    val name = list[0].toString()
    if (name.endsWith(suffix = "*")) return null
    return BibleName(
        name = name,
        bearers = list[1]!!.splitByNumbers().zip(list[2]?.splitByNumbers().orEmpty()),
        notes = list.drop(3).filterNotNull().filterNot { it.isNull() }
            .joinToString(separator = "\n", transform = { it.toString().trim() }).trim(),
    )
}

private fun GoogleSheetItem.splitByNumbers(): List<String> =
    this.toString().split("\\d+\\. ".toRegex()).filterNot { it.isEmpty() }.map { it.trim() }
